Apt.fn.extend('maps', {}, {
	/**
	 * Initialize reset button
	 */
	initReset() {
		const scope = this;
		const pub = scope.$public;

		if (! scope.conf.reset) {
			return;
		}

		$.events.on('$mapReset', 'mousedown', () => {
			scope.resetCenter();
		}, {
			delegate: scope.$overlay,
			namespace: scope.uid
		});

		pub.ready(() => {
			scope.initial = {
				center: pub.getCenter(true),
				zoom: pub.getZoom(true)
			};

			setTimeout(() => {
				if (scope.map) {
					scope.bindReset();
				}
			}, 400);
		});
	},

	/**
	 * Bind map move event
	 */
	bindReset() {
		const scope = this;
		const pub = scope.$public;

		pub.debounce('move', () => {
			if (scope.resetting) {
				return;
			}

			if (! $.equals(pub.getCenter(true), scope.initial.center)) {
				scope.model.$set('reset', true);
			}
		});
	},

	/**
	 * Reset map center
	 */
	resetCenter() {
		const scope = this;

		scope.resetting = true;

		scope.model.$set('reset', false);

		scope.$public.center(scope.initial.center, {
			animate: true,
			bearing: 0,
			zoom: scope.initial.zoom
		});

		setTimeout(() => {
			scope.resetting = false;
		}, 2000);
	}
});